import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { State } from 'store'
import Button from 'uiComponents/buttons'
import { DisabledItemHoverInfotip } from 'uiComponents/infotip'
import { useGetServiceAppsQuery } from '../../reduxQuery'
import { SERVICE_APP_LIMIT } from '../../schema'

export const NewServiceAppButton: React.FC = () => {
    const location = useLocation()
    const history = useHistory()
    const { data: apps = [] } = useGetServiceAppsQuery()
    const user = useSelector((state: State) => state.auth.user)
    const activeAccount = useSelector((state: State) => state.preferences.activeAccount)

    const knowsActivePark = !!activeAccount && (user?.accounts ?? []).some((a) => a.slug === activeAccount)
    const atLimit = apps.length >= SERVICE_APP_LIMIT
    const canCreate = !atLimit && knowsActivePark

    const handleClick = () => {
        const params = new URLSearchParams(location.search)
        params.set('addNew', 'true')
        history.replace(`${location.pathname}?${params.toString()}`)
    }

    return (
        <DisabledItemHoverInfotip
            active={!canCreate}
            infotipText={
                atLimit
                    ? `You already have ${SERVICE_APP_LIMIT} apps, which is the most we allow. Remove one you no longer use to make room.`
                    : 'Open one of your parks first. A new app is always made for the park you are working in.'
            }
            width="18rem"
            toTheLeft
        >
            <Button kind="action" disabled={!canCreate} onClick={handleClick}>
                + New service app
            </Button>
        </DisabledItemHoverInfotip>
    )
}
